import React from "react";
import { FaFacebookF, FaLinkedinIn, FaTwitter } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="bg-neutral-900 text-white py-8 mt-20">
      <div className="max-w-7xl mx-auto px-4 text-center">
        <h3 className="text-xl md:text-2xl font-extrabold mb-6">
          Let us know what you need and we'll get back to you within 24 hours!
        </h3>

        <div className="flex justify-left space-x-4 mb-6">
          <a href="https://facebook.com/smartguytechnologies" className="border border-white p-3 rounded-sm hover:bg-orange-500 transition">
            <FaFacebookF className="text-orange-500 text-lg" />
          </a>
          <a href="https://www.linkedin.com/company/smartguy-technologies" className="border border-white p-3 rounded-sm hover:bg-orange-500 transition">
            <FaLinkedinIn className="text-orange-500 text-lg" />
          </a>
          <a href="https://twitter.com/smartguy_tweets" className="border border-white p-3 rounded-sm hover:bg-orange-500 transition">
            <FaTwitter className="text-orange-500 text-lg" />
          </a>
        </div>

        <hr className="border-gray-700 my-6" />

        <p className="text-sm">© {new Date().getFullYear()} - Smartguy Technologies</p>

        <p className="text-sm mt-2">
          Call us at{" "}
          <a href="tel:18443846421" className="underline hover:text-gray-300">
            844-384-6421 ext 1
          </a>
        </p>
      </div>
    </footer>
  );
}


